import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";

//Import actions
import { getCampaignPage as onGetCampaignPages, addNewCampaignPage as onAddNewCampaignPage, updateCampaignPage as onUpdateCampaignPage, deleteCampaignPage as onDeleteCampaignPage, getCampaignPageLoading } from "../../../store/campaignPage/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

const CampaignPage = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();

  const { clients, clientLoading, companies, companyLoading, campaignPages, isCampaignPageCreated, isCampaignPageSuccess, loading, error } = useSelector((state) => ({
    campaignPages: state.CampaignPage.campaignPages,
    isCampaignPageCreated: state.CampaignPage.isCampaignPageCreated,
    isCampaignPageSuccess: state.CampaignPage.isCampaignPageSuccess,
    loading: state.CampaignPage.loading,
    error: state.CampaignPage.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [campaignPageList, setCampaignPageList] = useState([]);
  const [campaignPage, setCampaignPage] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    }];

  const typeData = [
    {
      options: [
        { label: "Page", value: "Page" },
        { label: "Banner", value: "Banner" },
      ],
    }];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const onClickDelete = (campaignPage) => {
    setCampaignPage(campaignPage);
    setDeleteModal(true);
  };

  const handleDeleteCampaignPage = () => {
    if (campaignPage) {
      dispatch(onDeleteCampaignPage(campaignPage));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setCampaignPageList(campaignPages);
  }, [campaignPages]);

  useEffect(() => {
    if (!isEmpty(campaignPages)) setCampaignPageList(campaignPages);
  }, [campaignPages]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredCampaignPages = campaignPages;
      if (type !== "all") {
        filteredCampaignPages = campaignPages.filter((campaignPage) => campaignPage.campaign_page_status.name === type);
      }
      setCampaignPageList(filteredCampaignPages);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`)
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId
        });
        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId
        });

        dispatch(onGetCampaignPages());
        dispatch(resetClientState());
        dispatch(getClient());
        handleGetCompany(obj.data.clientId);
      }
    }
  }, [dispatch, isSearch]);

  useEffect(() => {
    setCampaignPage(campaignPages);
  }, [campaignPages]);

  useEffect(() => {
    if (!isEmpty(campaignPages)) {
      setCampaignPage(campaignPages);
      setIsEdit(false);
    }
  }, [campaignPages]);

  useEffect(() => {
    if (!isEmpty(campaignPages)) {
      setCampaignPageList(campaignPages);
    }
  }, [campaignPages]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCampaignPage(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleCampaignPageClick = useCallback((arg) => {
    const campaignPage = arg;
    setCampaignPage({
      id: campaignPage.id,
      name: campaignPage.name,
      type: campaignPage.type && { label: campaignPage.type, value: campaignPage.type },
      description: campaignPage.description,
      company:
        campaignPage.campaign_page_company && {
          label: campaignPage.campaign_page_company.name,
          value: campaignPage.campaign_page_company.id,
        },
      client:
        campaignPage.asset_class_client && {
          label: campaignPage.campaign_page_client.name,
          value: campaignPage.campaign_page_client.id,
        },
    });

    setIsEdit(true);
    toggle();
  }, [toggle, userType]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (campaignPage && campaignPage.name) ?? "",
      type: (campaignPage && campaignPage.type) ?? "",
      description: (campaignPage && campaignPage.description) ?? "",
      client: (campaignPage && campaignPage.client) || clientSelected,
      company: (campaignPage && campaignPage.company) || companySelected,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter shipment name"),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      company: Yup.object().required("Please Select Company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getCampaignPageLoading());
      if (isEdit) {
        const updateCampaignPage = {
          id: campaignPage ? campaignPage.id : 0,
          name: values.name,
          type: values.type.value,
          description: values.description,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onUpdateCampaignPage(updateCampaignPage));
        validation.resetForm();
      } else {
        const newCampaignPage = {
          name: values.name,
          type: values.type.value,
          description: values.description,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onAddNewCampaignPage(newCampaignPage));
        validation.resetForm();
      }
      toggle();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteCampaignPage(element.value));
    });
    checkall.checked = false;
  };

  // Column
  const columns = useMemo(() => [
    {
      id: "#",
      Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
      Cell: (cellProps) => {
        let data = cellProps.row.original;
        return (
          <div className="hstack gap-2 mt-4 mt-sm-0">
            <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
            <ButtonGroup className="me-1">
              <UncontrolledButtonDropdown>
                <Button color="light" className="btn-sm" onClick={() => {
                  handleCampaignPageClick(data);
                }}><i className="ri-edit-2-line fs-15"></i></Button>
                <Button color="light" className="btn-sm" onClick={() => {
                  onClickDelete(data);
                }}><i className="ri-delete-bin-line fs-15 text-danger"></i></Button>
              </UncontrolledButtonDropdown>
            </ButtonGroup>
          </div>
        );
      },
    },
    {
      Header: "Campaign Name",
      accessor: "name",
      filterable: true,
    },
    {
      Header: "Campaign Type",
      accessor: "type",
      filterable: true,
    },
    {
      Header: "Keterangan",
      accessor: "description",
      filterable: true,
    },
    {
      Header: "Status",
      accessor: "campaign_page_status.name",
      filterable: true,
      Cell: (cell) => {
        switch (cell.value) {
          case "DRAFT":
            return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          case "ACTIVE":
            return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
          case "INACTIVE":
            return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
          default:
            return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
        }
      },
    }], [handleCampaignPageClick]);


  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  //TABLE
  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: campaignPageList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  function handleCampaignPageStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      type: "Purchase",
    };
    dispatch(onGetCampaignPages(param));
  }

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  document.title = "Campaign Templates | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={campaignPageList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteCampaignPage} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Campaign Templates" pageTitle="Procurements" />
        <Row>
          <Col lg={12}>
            <Card id="campaignPageList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Campaign Template Data &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className="btn btn-primary add-btn me-2"
                      id="create-btn"
                      onClick={() => {
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
                    </button>
                    <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
                    </button>
                    <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"><i className="ri-booklet-line me-1 align-bottom fs-14"></i> All Campaigns
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"><i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")} onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")} onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"><i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Search...`}
                                value={searchValue ?? ""} /><i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}><i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">Page <strong> {pageIndex + 1} of {pageOptions.length}</strong></Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Campaign Template" : "Add Campaign Template"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp; {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp; {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}></Select>
                          </div>
                          <div className="mb-3">
                            <Select
                              name="type"
                              placeholder="Select Type"
                              value={validation.values.type}
                              onChange={(e) => {
                                validation.setFieldValue("type", e);
                              }}
                              options={typeData}></Select>
                            {validation.touched.type && validation.errors.type && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.type}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">Campaign Name</Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Enter name" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}>Tutup</button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add Campaign Template"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CampaignPage;
